import React, { useEffect, useState } from 'react'
import SearchIcon from '@material-ui/icons/Search'
import injectStyles from 'react-jss'
import StyledIconButton from '../../Form/StyledIconButton'
import { styles } from './styled'
import { urlAdd } from '../../../Utils/URL'

const LiveMapSearchInput = props => {
  const { classes, suggestions, searchHandler, placeholder } = props
  const [text, setText] = useState('')
  const [localSuggestions, setLocalSuggestions] = useState([])
  const [openedSuggestions, setOpenedSuggestions] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const tableSearch = urlParams.get('tableSearch')
    if (tableSearch) {
      setText(tableSearch)
      onChanges(tableSearch)
    }
  }, [])

  useEffect(() => {
    const newSuggestions = (suggestions || []).filter(s =>
      s.toLowerCase().includes(text),
    )
    if (text) {
      setLocalSuggestions(newSuggestions)
      setOpenedSuggestions(newSuggestions.length > 0)
    }
  }, [text])

  const onChanges = value => {
    urlAdd('tableSearch', value)
    setOpenedSuggestions(false)
    searchHandler(value)
  }

  return (
    <div className={classes.container}>
      <div className={classes.inputContainer}>
        <input
          className={classes.input}
          onChange={event => {
            setText(event.target.value)
          }}
          value={text}
          onKeyUp={event =>
            event.keyCode === 13 || !event.target.value ? onChanges(text) : ''
          }
          placeholder={
            placeholder ? placeholder : 'Search client or campaign...'
          }
        >
          {props.children}
        </input>
        <div className={classes.searchIcon}>
          <StyledIconButton
            onClick={() => {
              onChanges(text)
            }}
          >
            <SearchIcon />
          </StyledIconButton>
        </div>
      </div>

      {openedSuggestions && localSuggestions.length > 0 && (
        <div className={classes.suggestions}>
          <ul>
            {localSuggestions.map(s => (
              <li
                onClick={() => {
                  setText(s)
                  onChanges(s)
                }}
              >
                {s}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(LiveMapSearchInput)



// WEBPACK FOOTER //
// ./src/Components/LiveMap/SearchInput/index.js